"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("./globalRules/index.vue"));
var _index2 = _interopRequireDefault(require("./specificProductRules/index.vue"));
var _index3 = _interopRequireDefault(require("./notificationSettings/index.vue"));
var _index4 = _interopRequireDefault(require("@/views/priceSetting/component/explainCard/index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "monitoringConfig",
  components: {
    GlobalRules: _index.default,
    SpecificProductRules: _index2.default,
    NotificationSettings: _index3.default,
    ExplainCard: _index4.default
  },
  data: function data() {
    return {
      activeName: 'specificProductRules' // 当前选中tab
    };
  },
  mounted: function mounted() {
    // 初始化第一个tab的数据
    this.getDetail(this.activeName);
  },
  methods: {
    // tab点击切换
    handleClick: function handleClick(tab) {
      if (!tab.name) return;
      var newActiveName = tab.name;
      // 先更新 activeName
      this.activeName = newActiveName;
      this.getDetail(newActiveName);
    },
    // 获取对应tab的数据
    getDetail: function getDetail(tabName) {
      var _this = this;
      this.$nextTick(function () {
        switch (tabName) {
          case 'globalRules':
            // 全局规则
            // this.$refs.globalRulesRef.getDetail()
            break;
          case 'specificProductRules':
            // 特定商品规则
            _this.$refs.specificProductRulesRef.getList();
            break;
          case 'notificationSettings':
            // 通知设置
            // this.$refs.notificationSettingsRef.getDetail()
            break;
        }
      });
    }
  }
};